import { gql } from '@apollo/client';

export const ALL_ASSIGNED_INSTITUTIONS = gql`
  query AllAssignedInstitutions($input: InstitutionPortalInstitutionsInput!) {
    institutions: allAssignedInstitutions(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id

          addressee
          ageRange0To18Months
          ageRange18MonthsTo3Years
          ageRange3To4Years
          ageRange4To5Years
          ageRange5To6Years
          allocation
          appliedForEcdEsrf
          areaOffice {
            id
            name
          }
          assessedForMaintenanceGrant
          certificateNumber
          componentNumber
          dateEcdEsrfReceived
          duplicateAction
          duplicateReference
          ecdRegistrationProgress
          ecdServiceType
          educatorNumber
          emisNumber
          exDept
          examCentre
          examNumber
          expiryDate
          facsimile
          fundedThroughConditionalGrant
          fundedThroughEquitableShare
          gisAltitude
          gisLatitude
          gisLongitude
          gisSource
          gradeROffered
          identifiedBy
          identifiedDate
          isArchived
          issueDate
          learnerNumber
          locality
          monthlyFeeRangeHighest
          monthlyFeeRangeLowest
          name
          nas
          nearestPointOfInterest
          newEmisNumber
          newOrRenewal
          noFeeSchool
          nodalArea
          npoNumber
          numberOfChildrenEnrolled
          numberOfChildrenFunded
          numberOfStaff
          officeContactNumber
          officeEmailAddress
          oldEmisNumber
          organisationName
          networkName
          openBoardingSchool
          ownerBuild
          ownerLand
          ownership
          paypointNumber
          physicalAddress
          pointOfInterest
          postalAddress
          postalCode
          privateOrNpo
          provinceCD
          quintile
          reasonForDuplicateAction
          receivedEcdEsrf
          receivedMaintenanceGrant
          registrationDate
          registrationNumber
          registrationOffice {
            id
            isInstitution
            isServiceProvider
            institution {
              id
              name
            }
            serviceProvider {
              id
              name
            }
          }
          registrationStatus {
            id
            name
          }
          section21
          section21Function
          specialization
          status
          streetAddress
          streetNo
          suburb
          townCity
          townshipVillage
          streetBuilding
          area
          verified
          validated
          wardID
          wardLabel
          year
          yearOfReceipt
          languageOfLearning
          closingTime
          openingTime
          afterCareForSchoolGoing
          primarySchoolName
          primarySchoolEmis
          isEcdServicePrimarySchoolBased
          hasHolidays
          numberOfDaysServiceOperate
          yearEcdStartedOperating
          legalEntity
          registeredAsNpo

          alternativeContactPerson {
            id
            designation
            name
            lastName
            contactNumber
            emailAddress
          }
          contactPerson {
            id
            designation
            name
            lastName
            contactNumber
            emailAddress
          }
          circuit {
            id
            name
          }
          country {
            id
            name
          }
          district {
            id
            name
          }
          districtMunicipality {
            id
            name
          }
          fundingClassification {
            id
            name
          }
          interventions {
            id
            name
          }
          localMunicipality {
            id
            localMunicipality
            localMunicipalityShorthand
          }
          ministry {
            id
            name
          }
          organisationUsersAddOns {
            id
            name
          }
          organisationUsersPlan {
            id
            name
          }
          personInCharge {
            id
            firstName
            lastName
            contactNumber
            email
          }
          phase {
            id
            name
          }
          province {
            id
            name
          }
          registrationType {
            id
            name
          }
          schoolType {
            id
            name
          }
          sector {
            id
            name
          }
          socialServicesProfessional {
            id
            firstName
            lastName
          }
          specializationGroup {
            id
            name
          }
          sspSupervisor {
            id
            firstName
            lastName
          }
          type {
            id
            name
          }
        }
      }
    }
  }
`;
